module.exports = __webpack_public_path__ + "img/level-ranked.c53bbb07.svg";